var render, staticRenderFns
import script from "./CategoryPagination.vue?vue&type=script&lang=ts&"
export * from "./CategoryPagination.vue?vue&type=script&lang=ts&"
import style0 from "./CategoryPagination.vue?vue&type=style&index=0&id=55141cf6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55141cf6",
  null
  
)

export default component.exports